import { ADD_MODIFIERS } from './types'

export const addModifiers = items => ({
  type: ADD_MODIFIERS,
  payload: { items }
})
